"use strict";

/** Main file for importing `HeatmapComponent` as a dependency */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heatmap = exports.demos = exports.ColorScale = exports.Color = void 0;
var tslib_1 = require("tslib");
var color_1 = require("./heatmap-component/data/color");
Object.defineProperty(exports, "Color", {
  enumerable: true,
  get: function () {
    return color_1.Color;
  }
});
var color_scale_1 = require("./heatmap-component/data/color-scale");
Object.defineProperty(exports, "ColorScale", {
  enumerable: true,
  get: function () {
    return color_scale_1.ColorScale;
  }
});
exports.demos = tslib_1.__importStar(require("./heatmap-component/demo"));
var heatmap_1 = require("./heatmap-component/heatmap");
Object.defineProperty(exports, "Heatmap", {
  enumerable: true,
  get: function () {
    return heatmap_1.Heatmap;
  }
});